// src/components/store/sections/weekly-banner/WeeklyBannerV41OrigamiribbonFuchsiaGlow.tsx
"use client";

import React from "react";
import DynamicWeeklyBannerVariant from "./DynamicWeeklyBannerVariant";

export default function WeeklyBannerV41OrigamiribbonFuchsiaGlow(props: any) {
  return (
    <DynamicWeeklyBannerVariant
      variantNumber={41}
      archKey="origami_ribbon"
      archLabel="Origami Folded Ribbon"
      palName="FuchsiaGlow"
      grad="from-fuchsia-500 via-pink-500 to-purple-700"
      lightBg="bg-fuchsia-50"
      textCol="text-fuchsia-700"
      borderCol="border-fuchsia-200"
      {...props}
    />
  );
}
